import Button from 'components/Button'
import Container from 'components/Container'
import Link from 'components/Link'
import { PageSEO } from 'components/SEO'
import Timeline from 'components/Timeline'
import resumeData from 'data/resumeData'
import siteMetadata from 'data/siteMetadata'
import { trackEvent } from 'lib/utils/analytics'

export default function Resume() {
  const onResumeDownloadClick = () => {
    trackEvent({ name: 'Resume Download', data: { link: siteMetadata.resumeDownloadLink } })
  }

  return (
    <Container>
      <PageSEO
        title={`Resume - ${siteMetadata.title}`}
        description="Check out how my journey have been like over the years"
      />
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        <div
          className="pt-6 pb-8 space-y-2 md:space-y-5 flex flex-col gap-4 md:flex-row justify-between items-end lg:items-center"
          data-aos="zoom-in-down"
        >
          <div className="space-y-4">
            <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
              Resume
            </h1>
            <p className="text-lg leading-7 text-gray-500 dark:text-gray-300">
              Check out how my journey have been like over the years
            </p>
          </div>
          {siteMetadata.enableResumeDownload && (
            <div>
              <Link href={siteMetadata.resumeDownloadLink} target="_blank">
                <Button onClick={onResumeDownloadClick} variant="outline">
                  Download Resume
                </Button>
              </Link>
            </div>
          )}
        </div>
        <div className="py-12 px-4">
          <Timeline timelines={resumeData} />
        </div>
      </div>
    </Container>
  )
}
